import { Modal, Button, Form, CloseButton, Accordion } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { getHostName } from "../helpers/utils";

function AffiliateModal({ show, handleClose, payload, setPayload }) {
  console.log(payload);

  const hostname = getHostName();

  // const [loader, setLoader] = useState(false);

  const ApplyForDB = async (values, { setSubmitting, resetForm }) => {
    console.log(values);
    // setSubmitting(false);

    // let obj = { ...values };

    // console.log(obj);

    // return;

    axios
      .post(`${hostname}/api/users/apply-for-affiliate`, {
        ...values,
      })
      .then((res) => {
        console.log(res.data);
        toast.success("Request Sent. we will reach you shortly via email", {
          theme: "colored",
        });
        setSubmitting(false);
        resetForm();
        handleClose();
        setPayload({});
      })
      .catch((err) => {
        console.log(err);
        setSubmitting(false);
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      style={{ backdropFilter: "blur(3px)" }}
    >
      <Modal.Header>
        <Modal.Title>{payload.loadType}</Modal.Title>
        <CloseButton onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        {payload.loadType === "Apply for Affiliate" && (
          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              email: "",
              phone: "",
              reference_by_code: "",
              address: "",
              city: "",
              postal: "",
              country: "Pakistan",
            }}
            validationSchema={Yup.object().shape({
              first_name: Yup.string().required("First name is required"),
              last_name: Yup.string().required("Last name is required"),
              email: Yup.string()
                .email("Invalid email")
                .matches(
                  /^[\w.+-]+@gmail\.com$/,
                  "Only @gmail.com emails are allowed"
                )
                .required("Email is required"),
              phone: Yup.string().required("Phone is required"),
              reference_by_code: Yup.string().required(
                "Referral Code is required"
              ),

              address: Yup.string(),
              city: Yup.string(),
              postal: Yup.string(),
              country: Yup.string(),
            })}
            onSubmit={ApplyForDB}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Modal.Body>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="first_name"
                        value={values.first_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.first_name && !!errors.first_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.first_name}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="last_name"
                        value={values.last_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.last_name && !!errors.last_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.last_name}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.email && !!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-6 mb-3">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.phone && !!errors.phone}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.phone}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-12 mb-3">
                      <Form.Label>Referral Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="reference_by_code"
                        value={values.reference_by_code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.reference_by_code &&
                          !!errors.reference_by_code
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.reference_by_code}
                      </Form.Control.Feedback>
                    </div>

                    <div className="col-md-12 mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={values.address}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="postal"
                        value={values.postal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <Form.Label>Country</Form.Label>
                      <Form.Control
                        type="text"
                        name="country"
                        value={values.country}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="col-md-12" style={{ marginTop: "5px" }}>
                      <label style={{ marginBottom: "10px" }}>Payment</label>
                      <br />

                      <Accordion alwaysOpen>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <span className="me-2">
                              <i className="bi bi-bank2 custom-accordion-icon"></i>
                            </span>
                            Bank Deposit
                          </Accordion.Header>
                          <Accordion.Body>
                            IBAN: 11111111111111111111 <br />
                            Account Title: Moeein Khan <br />
                            Account Number: 2323224234233 <br />
                            Bank: Bank Name
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                  <div className="text-end">
                    <br />
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={isSubmitting}
                    >
                      Apply
                    </Button>
                  </div>
                </Modal.Body>
              </Form>
            )}
          </Formik>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default AffiliateModal;
